import { Navigate, Route, Routes } from "react-router-dom";
import { useAuth } from "./lib/api.jsx";
import Login from "./pages/Login.jsx";
import Layout from "./pages/Layout.jsx";
import Dashboard from "./pages/Dashboard.jsx";
import Users from "./pages/Users.jsx";
import Verify from "./pages/Verify.jsx";
import Packages from "./pages/Packages.jsx";
import Subscriptions from "./pages/Subscriptions.jsx";
import Portals from "./pages/Portals.jsx";
import Permissions from "./pages/Permissions.jsx";
import UserLogins from "./pages/UserLogins.jsx";
import Activity from "./pages/Activity.jsx";
import Notifications from "./pages/Notifications.jsx";
import Partners from "./pages/Partners.jsx";
import Files from "./pages/Files.jsx";
import AuditLog from "./pages/AuditLog.jsx";
import Trash from "./pages/Trash.jsx";
import ReferenceData from "./pages/ReferenceData.jsx";

export default function App() {
  const { token } = useAuth();
  if (!token) return <Login />;

  return (
    <Routes>
      <Route element={<Layout />}>
        <Route path="/" element={<Dashboard />} />
        <Route path="/users" element={<Users />} />
        <Route path="/verify" element={<Verify />} />
        <Route path="/packages" element={<Packages />} />
        <Route path="/subscriptions" element={<Subscriptions mode="subs" />} />
        <Route path="/payments" element={<Subscriptions mode="pay" />} />
        <Route path="/portals" element={<Portals />} />
        <Route path="/permissions" element={<Permissions />} />
        <Route path="/logins" element={<UserLogins />} />
        <Route path="/activity" element={<Activity />} />
        <Route path="/notifications" element={<Notifications />} />
        <Route path="/partners" element={<Partners />} />
        <Route path="/files" element={<Files />} />
        <Route path="/audit" element={<AuditLog />} />
        <Route path="/trash" element={<Trash />} />
        <Route path="/ref/:table" element={<ReferenceData />} />
        <Route path="*" element={<Navigate to="/" replace />} />
      </Route>
    </Routes>
  );
}
